export const PRIMARY_PURPLE = '#3D1B9D';
export const GREEN = '#019064';
export const RED = '#DB2B39';
export const LIGHT_PURPLE = '#E8E0F5';
export const LIGHT_GREEN = '#E0F5EE';
export const TABS = [
    { id: 'overview', labelKey: 'tabs.overview' },
    { id: 'tech_performance', labelKey: 'tabs.tech_performance' },
    { id: 'coaching_alerts', labelKey: 'tabs.coaching_alerts' },
    { id: 'my_stats', labelKey: 'tabs.my_stats' },
];
export const KPI_DATA = [
    {
        label: 'kpi.total_existing_issues',
        value: '--',
        trend: 'kpi.all_time',
        trendDirection: 'neutral',
        trendIsPositive: true
    },
    {
        label: 'kpi.total_open_issues',
        value: '0',
        trend: '0% kpi.open_rate',
        trendDirection: 'neutral',
        trendIsPositive: true,
    },
    {
        label: 'kpi.avg_processing_time',
        value: '--',
        trend: '0% kpi.vs_prior_period',
        trendDirection: 'neutral',
        trendIsPositive: true,
    },
    {
        label: 'kpi.avg_resubmissions',
        value: '0',
        trend: '0% kpi.vs_prior_period',
        trendDirection: 'neutral',
        trendIsPositive: true,
    },
    {
        label: 'kpi.escaped_issues',
        value: '0',
        trend: '0% kpi.vs_prior_period',
        trendDirection: 'neutral',
        trendIsPositive: true,
    },
];
export const SUMMARY_DATA = [
    {
        label: 'summary.issues_caught',
        value: '0',
        trend: '0% summary.vs_prior_period',
    },
    {
        label: 'summary.resolution_rate',
        value: '0%',
        trend: '0% summary.vs_prior_period',
    },
    {
        label: 'summary.estimated_time_saved',
        value: '0s',
        trend: 'summary.per_inspection',
    },
    {
        label: 'summary.techs_needing_coaching',
        value: '0',
        trend: '',
    },
];
